import React, {useEffect} from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Button from '@material-ui/core/Button';
import {Typography} from '@material-ui/core';
import {Settings as AdvancedIcon} from '@material-ui/icons';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import {range} from 'lodash';
import InlineRadioButtons from '../common/fields/InlineRadioButtons';
import {isEmpty} from 'lodash/lang';
import {PrimaryButton} from '../common/StyledButtons';

export default function QuizOptions(props) {
    const [open, setOpen] = React.useState(false);
    const [forceOpen, setForceOpen] = React.useState(false);
    const [feedback, setFeedback] = React.useState('none');
    const [passingGrade, setPassingGrade] = React.useState(50); //default to 50 for pass
    const [randomizeQuestions, setRandomizeQuestions] = React.useState('No');
    const [questionsPerPage, setQuestionsPerPage] = React.useState('One');
    const [webhookUrl, setWebhookUrl] = React.useState('');
    const {initialData, onChange, quizUUID} = props;

    useEffect(
        () =>
        {
            if (!isEmpty(initialData)) {
                setFeedback( initialData.showRecapCorrect ? 'full' :
                    initialData.showRecap ? 'detailed' :
                        initialData.showRecapResults ? 'summary' : 'none');
                if (initialData.passFailThreshold) {
                    setPassingGrade(initialData.passFailThreshold);
                }
                if (initialData.randomizeQuestions != null) {
                    setRandomizeQuestions(initialData.randomizeQuestions ? 'Yes' : 'No');
                }
                if (initialData.singleQuestionPages != null) {
                    setQuestionsPerPage(initialData.singleQuestionPages ? 'One' : 'All');
                }
                if (initialData.webhookUrl) {
                    setWebhookUrl(initialData.webhookUrl);
                }
            }
        }
        , [initialData]);

    useEffect(() =>
        props.updateAdvancedOptions({
            feedback: feedback,
            passingGrade: passingGrade,
            randomizeQuestions: randomizeQuestions,
            questionsPerPage: questionsPerPage,
            webhookUrl: webhookUrl}), [feedback, passingGrade, randomizeQuestions, questionsPerPage, webhookUrl]);

    const handleClick = () => {
        setOpen(prev => !prev);
    };

    const handleClickAway = () => {
        if (!forceOpen) {
            setOpen(false);
        } else {
            setForceOpen(false);
        }
    };

    const handleFeedbackSelect = ({target: {value}}) => {
        setFeedback(value);
        setForceOpen(true);
        onChange();
    };

    const handleGradeSelect = ({target: {value}}) => {
        setPassingGrade(parseFloat(value));
        setForceOpen(true);
        onChange();
    };

    const handleRandomizeQuestionChange = ({target: {value}}) => {
        setRandomizeQuestions(value);
        setForceOpen(true);
        onChange();
    };

    const handleQPPChange = ({target: {value}}) => {
        setQuestionsPerPage(value);
        setForceOpen(true);
        onChange();
    };

    const handleWebhookChange = ({target: {value}}) => {
        setWebhookUrl(value);
        onChange();
    };

    const generateGradeMenuItems = (granularity = 5) => {
        granularity = granularity > 0 ? granularity : 5; // default to 5 if invalid value
        const menuItemArray = range(granularity, 100 + granularity, granularity).reverse();
        return (
            menuItemArray.map((value) =>
                <MenuItem key={value} value={value}>{value}</MenuItem>
            )
        );
    };


    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <div>
                <PrimaryButton onClick={handleClick}><AdvancedIcon/> &nbsp; Advanced Options</PrimaryButton>
                {open ? (
                    <Grid container className="outlined offset-minus-10" spacing={2} alignContent="center" alignItems="center">
                        <Grid item xs={4}>
                            <Typography variant="subtitle1">Feedback</Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <TextField
                                className="feedback-input"
                                select
                                value={feedback}
                                onChange={handleFeedbackSelect}
                                variant="outlined"
                            >
                                <MenuItem value={'none'}>None</MenuItem>
                                <MenuItem value={'summary'}>Summary Overview</MenuItem>
                                <MenuItem value={'detailed'}>Detailed Overview</MenuItem>
                                <MenuItem value={'full'}>Detailed including Answer key</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography variant="subtitle1">Passing Grade</Typography>

                        </Grid>
                        <Grid item xs={8}>
                            <TextField
                                className="passing-grade-input"
                                value={passingGrade}
                                onChange={handleGradeSelect}
                                variant="outlined"
                                type="number"
                            >
                            </TextField>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography variant="subtitle1">Randomize Questions?</Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <InlineRadioButtons
                                groupName="randomize-questions"
                                radioOptions={['Yes', 'No']}
                                onChange={handleRandomizeQuestionChange}
                                currentlySelected={randomizeQuestions}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography variant="subtitle1">Questions Per Page</Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <InlineRadioButtons
                                groupName="questions-per-page"
                                radioOptions={['All', 'One']}
                                onChange={handleQPPChange}
                                currentlySelected={questionsPerPage}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Typography variant="subtitle1">Webhook URL</Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <TextField variant="outlined" onChange={handleWebhookChange} fullWidth value={webhookUrl}/>
                        </Grid>
                        <Grid item xs={4}/>
                        <Grid item xs={8}>
                            <Typography variant="caption">Quiz UUID: {quizUUID}</Typography>
                        </Grid>
                    </Grid>
                ) : null}
            </div>
        </ClickAwayListener>
    );
}